import React, { Component } from 'react';
import {
    Grid,
    Card,
    FormControl,
    Select,
    MenuItem,
    Button,
    TextField
} from '@mui/material';
import { Helmet } from 'react-helmet';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import { _axios } from 'src/plugins/axios';


class SearchByEmployeeDetailsNav extends Component {
    constructor() {
        super();
        this.state = {
            searchType: null
        }
    }

    componentDidMount = () => {
        this.setState({ searchType: this.props.searchBarPlaceholders[0] })
    }

    render() {
        return (
            <>
                <Grid
                    container
                    sx={{
                        width: '100%',
                        borderRadius: 4,
                        p: 3,
                        pb: 0,
                        pt: 2
                    }}
                >
                    <Grid item xs={12}>
                        <Card
                            sx={{
                                width: '100%',
                                borderRadius: 4,
                                mb: 2,
                                p: 3,
                                boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                            }}
                        >
                            <FormControl sx={{
                                mr: 1,
                                width: { sm: 'auto', md: '13%' },
                                textAlign: 'center'
                            }}>
                                <Select
                                    id="mto-searchType"
                                    defaultValue={this.props.menuItemList[0].value}
                                    onChange={(e) => {
                                        this.props.menuItemList?.map((obj, idx) => {
                                            if (e?.target?.value == obj?.value)
                                                this.setState({ searchType: this.props.searchBarPlaceholders[idx] })
                                        })
                                    }}
                                >
                                    {
                                        this.props.menuItemList?.map((ele) => {
                                            return (
                                                <MenuItem value={ele?.value}>{ele?.placeholder}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl sx={{
                                width: { sm: 'auto', md: '30%' }
                            }}>
                                <TextField
                                    id="mto-search"
                                    variant="standard"
                                    placeholder={this.state.searchType}
                                />
                            </FormControl>
                            <Button sx={{
                                ml: { xs: 0, sm: 2 },
                                px: 3,
                                boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                                mt: { xs: 2, sm: 0 }
                            }}
                                color="primary"
                                startIcon={<SearchIcon size="18" />}
                                onClick={() => this.props.handleSubmit(this.state.searchType)}
                            > Submit</Button>
                        </Card>
                    </Grid>
                </Grid>
            </>
        )

    }
}

export default SearchByEmployeeDetailsNav;